<span class="text-h1 font-head">Product Documents</span>

<form (ngSubmit)="search()" #thisForm="ngForm">
  <div class="mt-7 desktop:w-1/2 mx-auto">
    <span>
      {{ "product_finder_infotext" | translate }}
    </span>
    <div class="mt-5">
      <patternlib-dropdown
        label="{{ 'product_area_label' | translate }}"
        show-remove-icon="false"
        size="small"
        [disabled]="this.loadingProductAreas"
        [(ngWebComponentModel)]="this.selectedProductAreaId"
        (lhSelect)="this.onProductAreaChanged($event)"
      >
        <patternlib-option
          *ngFor="let item of productAreas"
          [value]="item.id"
          [label]="item.name"
        >
        </patternlib-option>
      </patternlib-dropdown>
    </div>
    <div class="mt-5">
      <patternlib-searchbox
        label="{{ 'serial_number_label' | translate }}"
        size="small"
        placeholder=""
        button-outside
        [readonly]="this.loadingProductAreas || !this.selectedProductAreaId"
        [(ngWebComponentModel)]="this.serialNumber"
        (lhChange)="this.onSerialNumberChanged()"
        (lhEnterPress)="this.search()"
        (lhSearch)="this.search()"
      />
    </div>
    <div *ngIf="this.loadingProducts; else showingProducts">
      <div
        class="relative flex flex-col items-center justify-center h-full my-7"
      >
        <patternlib-spinner spin></patternlib-spinner>
      </div>
    </div>
    <ng-template #showingProducts>
      <div class="mt-4" *ngIf="this.foundProducts">
        <span *ngIf="foundProducts.length === 0; else productsFound">
          {{ "no_results_found" | translate }}
        </span>
        <ng-template #productsFound>
          <patternlib-table-base>
            <tr slot="head">
              <th></th>
              <th>Product type</th>
              <th>Serial no.</th>
              <th></th>
            </tr>

            <patternlib-table-base-row
              *ngFor="let item of this.productsOnThisPage"
            >
              <patternlib-table-base-cell>
                <img
                  *ngIf="item.imageCdnId; else placeholder"
                  [src]="cloudinaryProductThumbnailBaseUrl + item.imageCdnId"
                  class="product-img my-1"
                />
                <ng-template #placeholder>
                  <div class="product-img my-1 ps-2 pt-2 bg-steel-300">
                    <patternlib-icon
                      [iconName]="item.productAreaId"
                      size="32px"
                    ></patternlib-icon>
                  </div>
                </ng-template>
              </patternlib-table-base-cell>
              <patternlib-table-base-cell>
                <span class="font-text-bold">{{ item.productModelName }}</span>
              </patternlib-table-base-cell>
              <patternlib-table-base-cell>
                {{ item.serialNumber }}
              </patternlib-table-base-cell>
              <patternlib-table-base-cell>
                <patternlib-radiobutton-item
                  value="{{ item.productId }}"
                  (lhRadiobuttonSelection)="this.onRadioButtonSelected($event)"
                  isInTable
                  #productRadiobuttonItems
                ></patternlib-radiobutton-item>
              </patternlib-table-base-cell>
            </patternlib-table-base-row>
          </patternlib-table-base>
          <div
            class="flex items-center min-h-[50px] py-[11px] px-[24px] border-t border-t-solid border-t-gray-300 bg-gray-100"
          >
            <patternlib-pagination
              [currentPage]="this.currentPage"
              [lastPage]="this.lastPage"
              (lhChange)="onPaginationChange($event)"
            >
              <span slot="dropdown-range-label">1..3 </span>
            </patternlib-pagination>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </div>
  <hr class="mt-7" />
  <div class="mt-5 flex items-end">
    <patternlib-button
      class="ml-auto"
      [disabled]="!this.selectedProductId"
      (click)="onSearchClick()"
    >
      {{ "button_search" | translate }}
    </patternlib-button>
  </div>
</form>
